// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1PACx","box":"WorkspacesBox_box__2Z9C1","node":"WorkspacesBox_node__3uUNQ"};